import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

// IMPORTANT: Assuming you have installed and configured Pinia for your project.
// If you use Vuex, the structure will be slightly different (mutations/actions).

export const useAuthStore = defineStore('auth', () => {
    // --- STATE (The data container) ---
    const jwtToken = ref(null);
    const currentStylist = ref(null);
    
    // --- GETTERS (Derived values) ---
    const isAuthenticated = computed(() => !!jwtToken.value && !!currentStylist.value);
    
    // --- ACTIONS (Functions that modify the state) ---

    // Function called after successful login
    function setStylistSession(token, stylistData) {
        // In a standard app, you'd save to localStorage here, 
        // but here we just store it in memory (the ref() objects).
        jwtToken.value = token;
        currentStylist.value = stylistData;
        console.log("Stylist session successfully saved to in-memory store.");
    }

    // Function called on logout
    function clearStylistSession() {
        // This is the core logic you needed!
        jwtToken.value = null;
        currentStylist.value = null;
        console.log("Stylist session successfully cleared from in-memory store.");
    }

    return { jwtToken, currentStylist, isAuthenticated, setStylistSession, clearStylistSession };
});